module.exports = __webpack_public_path__ + "static/media/resume.9073c9fa.pdf";